function backendBearerCredential(sessionId, organizationId, token) {
  const t = typeof token === 'string' ? token.trim() : '';
  if (t.includes('&')) return t;
  const sid = String(sessionId || '').trim();
  const oid = String(organizationId || '').trim();
  return `${sid}&${oid}`;
}

const LEADERBOARD_PATHS = {
  pvp: '/getLeaderboardPvp',
  ai: '/getLeaderboardAi',
  offline: '/getLeaderboardOffline',
};

/** Map stored category / gameMode values to API gameMode key. */
export function resolveLeaderboardGameMode(raw) {
  const mode = String(raw ?? '').trim().toLowerCase();
  if (mode === 'pvp' || mode === 'online') return 'pvp';
  if (mode === 'ai' || mode === 'vs-ai') return 'ai';
  if (
    mode === 'offline' ||
    mode === 'pass & play' ||
    mode === 'pass-play' ||
    mode === 'pass_play'
  ) {
    return 'offline';
  }
  return 'pvp';
}

export function resolveLeaderboardGameModeFromStorage() {
  try {
    const raw = sessionStorage.getItem('scoreboardData');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed?.categoryMode) {
        return resolveLeaderboardGameMode(parsed.categoryMode);
      }
      if (parsed?.isLobbyPvp) return 'pvp';
      if (parsed?.isPassPlay) return 'offline';
    }
  } catch {
    /* ignore */
  }
  try {
    return resolveLeaderboardGameMode(sessionStorage.getItem('gameMode'));
  } catch {
    return 'pvp';
  }
}

export async function fetchLeaderboard({
  gameMode,
  sessionId,
  organizationId,
  userId,
  token,
  lobby,
  limit = 2,
}) {
  const mode = resolveLeaderboardGameMode(gameMode);
  const path = LEADERBOARD_PATHS[mode];
  if (!path) {
    throw new Error(`Unsupported leaderboard gameMode: ${gameMode}`);
  }

  const bearer = backendBearerCredential(sessionId, organizationId, token);
  const body = {
    sessionId: String(sessionId || '').trim(),
    organizationId: String(organizationId || '').trim(),
    limit,
  };

  if (mode === 'pvp') {
    const lobbyName = String(lobby ?? '').trim();
    if (lobbyName) body.lobby = lobbyName;
  } else {
    body.userId = String(userId ?? '').trim();
  }

  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearer}`,
    },
    body: JSON.stringify(body),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data.success) {
    throw new Error(
      data?.message || data?.error || 'Failed to fetch leaderboard'
    );
  }

  return {
    gameMode: data.gameMode || mode,
    players: Array.isArray(data.players) ? data.players : [],
  };
}
